module.exports = __webpack_public_path__ + "static/img/govcard_white_07.3b203ac7.svg";